module.exports = __webpack_public_path__ + "img/android-qr.e1e089d2.png";